import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';

import BaseModal from '@fo/designSystem/BaseModal/BaseModal';
import Headers, {HeaderType} from '@fo/components/DesignSystem/Text/Headers/Headers';
import {fonts} from '@fo/shared/styles/variables';
import Button, {ButtonVariant} from '@fo/components/DesignSystem/Buttons/Button/Button';
import {getPageRoute} from '@fo/utils/routes/getPageRoute';
import {FormattedMessage, useIntl} from 'react-intl';
import AccountTypeCard from '@fo/components/Identity/CreateAccountTypeModal/AccountTypeCard';
import {useRedirectToTide, ESource} from '@fo/shared-hooks/useRedirectToTide';

import styles from './CreateAccountTypeModal.styles';

interface Props {
  onModalClose: () => void;
  showLogin: () => void;
}

function CreateAccountTypeModal({showLogin, onModalClose}: Props): ReactElement {
  const {formatMessage} = useIntl();
  const {redirectToTide} = useRedirectToTide();

  return (
    <BaseModal onClose={onModalClose}>
      <div data-testid="modal.createAccountTypePicker" className={cx(styles.container)}>
        <Headers headerType={HeaderType.H3} alignment={fonts.alignment.CENTER} className={cx(styles.title)}>
          <FormattedMessage id="createAccount.typeModal.title" />
        </Headers>
        <div className={cx(styles.cardContainer)}>
          <AccountTypeCard
            name="CustomerAccount"
            title={formatMessage({id: 'createAccount.typeModal.customer.title'})}
            description={formatMessage({id: 'createAccount.typeModal.customer.description'})}
            buttonLabel={formatMessage({id: 'createAccount.typeModal.customer.buttonLabel'})}
            href={undefined}
            onClick={() => {
              onModalClose();
              redirectToTide({source: ESource.CREATE_ACCOUNT});
            }}
            onClose={onModalClose}
          />
          <AccountTypeCard
            name="AdvisorAccount"
            title={formatMessage({id: 'createAccount.typeModal.advisor.title'})}
            description={formatMessage({id: 'createAccount.typeModal.advisor.description'})}
            buttonLabel={formatMessage({id: 'createAccount.typeModal.advisor.buttonLabel'})}
            href={getPageRoute('advisor.create.home')}
            onClose={onModalClose}
          />
        </div>
        <Button
          onClick={() => {
            onModalClose();
            showLogin();
          }}
          variant={ButtonVariant.LINK_TEXT}
          ariaLabel={formatMessage({id: 'phoenix.header.login.haveAccount'})}
          testId="ui.createAccountModal.alreadyRegistered"
        >
          <FormattedMessage id="phoenix.header.login.haveAccount" />
        </Button>
      </div>
    </BaseModal>
  );
}

export default CreateAccountTypeModal;
